import { RawConditionOperator } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

export type ParamOption = { label: string; value: string };

// ─── Params auto-inyectados por el backend ────────────────────────────────────

/**
 * El frontend no debe mostrarlos en el formulario ni enviarlos en el payload.
 */
export const BASE_PARAMS = [
  "api_base_url",
  "api_key",
  "nid",
  "user_id",
  "utility_api_base_url",
  "utility_api_key",
];

// ─── Variables de contexto (fallback si la API no devuelve context_columns) ───

export const CONTEXT_VARIABLES: ParamOption[] = [
  // Precios
  { label: "Precio mínimo actual",            value: "${precio_minimo_actual}"       },
  { label: "Precio mínimo inicial",           value: "${precio_minimo_inicial}"      },
  { label: "Precio publicación actual",       value: "${precio_publicacion_actual}"  },
  { label: "Precio publicación inicial",      value: "${precio_publicacion_inicial}" },
  { label: "Precio publicación",              value: "${precio_publicacion}"         },
  { label: "V-Price",                         value: "${v_price}"                    },
  { label: "V-Precio (BD)",                   value: "${v_precio}"                   },
  { label: "Precio estándar",                 value: "${precio_estandar}"            },
  { label: "Precio estándar mínimo",          value: "${precio_estandar_min}"        },
  // Días
  { label: "Días en inventario",              value: "${dias}"                       },
  { label: "Días comerciales",                value: "${dias_comerciales}"           },
  { label: "Días en Full",                    value: "${dias_full}"                  },
  { label: "Desistimiento últimos 15 días",   value: "${desistimiento_ultimos_15_dias}" },
  // Clasificación
  { label: "País",                            value: "${country}"                    },
  { label: "Tipo de publicación",             value: "${tipo_publicacion}"           },
  { label: "Categoría Grid",                  value: "${categorica_grid}"            },
  { label: "Categoría Bono 2",                value: "${categorica_bono_2}"          },
  { label: "Comisión",                        value: "${comision}"                   },
  // Otros
  { label: "Apuesta",                         value: "${apuesta}"                    },
];

export const CONDITION_OPERATORS: { value: RawConditionOperator; label: string }[] = [
  { value: "equals",           label: "= igual a"         },
  { value: "not_equals",       label: "≠ distinto de"     },
  { value: "greater_than",     label: "> mayor que"        },
  { value: "greater_or_equal", label: "≥ mayor o igual a" },
  { value: "less_than",        label: "< menor que"        },
  { value: "less_or_equal",    label: "≤ menor o igual a" },
  { value: "contains",         label: "∈ contiene"         },
  { value: "not_contains",     label: "∉ no contiene"      },
];
